import { gql } from '@apollo/client';

export const GET_INDICATOR_FRAMEWORK = gql`
  query GetIndicatorFramework($id: ID!) {
    indicatorFramework: getIndicatorWorkspace(id: $id) {
      id
      name
      frameworkType {
        id
        name
        indicatorsOnly
        levels {
          id
          name
          level
          allowIndicators
        }
      }
      intervention {
        id
        name
        reporters {
          id
          assignee {
            id
            firstName
            lastName
          }
          organisation {
            id
            isFunder
            isInstitution
            isServiceProvider
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
      }
      programme {
        id
        name
        reporters {
          id
          assignee {
            id
            firstName
            lastName
          }
          organisation {
            id
            isFunder
            isInstitution
            isServiceProvider
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
      }
      frameworkResults {
        id
        type
        number
        description
        objectiveName
        default {
          id
        }
        level {
          id
          level
        }
        parentResult {
          id
        }
        indicators {
          id
          measurementUnit
          type
          unit
          name
          indicatorLabel
          startDate
          endDate
          target
          targetValue
          description
          resultRelationship
          hasTargets
          hasBaseline
          minValueAllowed
          maxValueAllowed
          dataSources
          applyCurrencyConversion
          exchangeRate
          outcomeTheme {
            id
            name
          }
          period {
            id
            name
          }
          currencyGroup {
            id
            name
          }
          categories {
            id
            category {
              id
              name
              status
            }
            option {
              id
              name
            }
          }
          dimensions {
            id
            index
            name
            options
          }
          benchmarks {
            id
            index
            name
            description
            benchmark {
              id
              name
              description
            }
          }
          periodsCount
          periods {
            id
            periodDate
            periodNumber
            label
          }
          targets {
            id
            value
            periodDate
            periodNumber
            dimensionOptions
            site {
              id
              name
            }
          }
          dataSource
          dataSourceOption
          datasetDataSource {
            id
            description
          }
          calculation
          calculationMethod
          dataSourceWorkspace {
            id
            name
          }
          includeEmptyRows
          baselineOrTargetValue
          baselineDate
          baselineValue
          timeline
          trackProgressStatus
          statusTier
          statusType
          trackingHierarchy {
            id
            name
          }
          trackingHierarchyLevel {
            id
            typeOfSite
            value
          }
          trackedByOrganisation
          calculateStatus
          basedOn
          allStatusOverides
          progressStatusConditions {
            id
            index
            status
            value1
            value2
            operator
          }
          trackingOrganisation
          sites {
            id
            name
          }
          firstPeriod {
            id
            label
            periodDate
          }
          periodGroup {
            id
            name
          }
          indicatorPeriodType
        }
      }
      reporters {
        id
        assignee {
          id
          firstName
          lastName
        }
        organisation {
          id
          isFunder
          isInstitution
          isServiceProvider
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
      monitoringForms {
        id
        name
        description
        captureValue
        version
        published
        supportingDocuments
        allowCurrency
        currencies {
          id
          currencyGroup {
            id
            name
            exchangeRate
          }
        }
        period {
          id
          name
        }
        indicators {
          id
          indicator {
            id
            name
            period {
              id
              name
            }
            frameworkResult {
              id
            }
            trackingHierarchy {
              id
              name
            }
            trackingHierarchyLevel {
              id
              typeOfSite
              value
            }
          }
          dimensions
          site {
            id
            name
          }
        }
        reporters {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        formReporters {
          id
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          sites {
            id
          }
        }
        users {
          id
          reporter {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          user {
            id
            firstName
            lastName
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          formRole {
            id
            name
          }
          sites {
            id
          }
        }
        dueDates {
          id
          date
          periodNumber
        }
        associatedForms {
          id
          name
          published
        }
        associatedActivities {
          id
          name
          intervention {
            id
            name
          }
        }
        sites {
          id
          site {
            id
            name
            organisation {
              funder {
                id
                name
              }
              serviceProvider {
                id
                name
              }
              institution {
                id
                name
              }
            }
          }
          indicator {
            id
            name
          }
          hierarchyLevel {
            id
            typeOfSite
          }
        }
      }
    }
  }
`;
